// Mixin with methods necessary for AristotleFilePond.vue
export default {
    methods: {
        submitFile: function () {
            this.$refs.aristotlepond.submitFile()
        },
        changeProgress: function (progress) {
            this.percentageCompleted = Math.floor(progress * 100) / this.numberOfSteps
        },
        changeTags: function (tags) {
            this.currentTags = tags
        },
        changeLoadingMessage: function (loadingMessage) {
            this.loadingMessage = loadingMessage
        },
        changeNumberOfSteps: function (numberOfSteps) {
            this.numberOfSteps = numberOfSteps
        },
        changeFileIsLoaded: function (fileIsLoaded) {
            this.fileIsLoaded = fileIsLoaded
        },
        changeErrors: function (errors) {
            this.errors = errors
        },
        changeListOfMetadataRepresentations: function (listOfMetadataRepresentations) {
            this.listOfMetadataRepresentations = listOfMetadataRepresentations
        },
        changeIsLoading: function (isLoading) {
            this.isLoading = isLoading
        },
        changeExcelToCsvMessage: function (excelToCsvMessage) {
            this.excelToCsvMessage = excelToCsvMessage
        },
        changeShowLoginMessage: function (showLoginMessage) {
            this.showLoginMessage = showLoginMessage
        },
        changeSelectedWorkgroup: function (selectedWorkGroup) {
            this.selectedWorkGroup = selectedWorkGroup
        },
    },
}

